import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

function AuthRedirect() {
  const navigate = useNavigate();
  const { instance } = useMsal();

  useEffect(() => {
    const completeRedirect = async () => {
      try {
        const response = await instance.handleRedirectPromise();
        const account =
          response?.account ||
          instance.getActiveAccount() ||
          instance.getAllAccounts()[0] ||
          null;

        if (account) {
          instance.setActiveAccount(account);
        }
      } catch (error) {
        console.error("Errore durante il callback di login:", error);
      }

      // If this page was opened as a popup by loginPopup, close it after redirect handling.
      if (window.opener && window.opener !== window) {
        window.close();
      } else {
        navigate("/", { replace: true });
      }
    };

    completeRedirect();
  }, [instance, navigate]);

  return <div>Reindirizzamento in corso...</div>;
}

export default AuthRedirect;
